import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import { BackofficeImage } from '@/components/BackofficeImage/BackofficeImage'
import { useHeaderContext } from '@/context/header'
import { formatDocumentNumber, labelByDocumentType } from '@/utils/format/documentNumber'
import { FadeIn } from '@/utils/useFadeIn/useFadeIn'

import * as S from './HeaderDetails.styles'

const HeaderDetails = () => {
  const {
    member,
    memberStatus: { isBlocked }
  } = useHeaderContext()

  return (
    <Box css={S.headerDetailRootCss} data-will-show-info={!!member?.documentNumber}>
      {!!member?.documentNumber && (
        <Box css={S.fixedContainerCss}>
          <FadeIn>
            <Flex>
              <Box css={S.sidebarPlaceholderCss}>
                <Box css={S.sidebarPlaceholderInnerCss} />
              </Box>
              <Flex css={S.centerFlexCss} justify="center">
                <Flex align="center" css={S.contentRowCss} gap="$7">
                  <Box css={S.chevronPanelCss}>
                    <Box css={S.infoPanelCss}>
                      <Flex css={S.infoRowCss} gap="$7">
                        <Flex gap="$3" align="center">
                          <Box alt="Ícone de usuário" as={BackofficeImage} height={32} src="/img/user.svg" width={32} />
                          <Box>
                            <FloraTypography fontSize="exceptionsAuxiliar">Nome</FloraTypography>
                            <FloraTypography css={S.usernameCss} fontSize="bodyLargeStandard">
                              {member.username}
                            </FloraTypography>
                          </Box>
                        </Flex>
                        <Box css={S.documentBoxCss}>
                          <FloraTypography fontSize="exceptionsAuxiliar">
                            {labelByDocumentType(member?.documentType)}
                          </FloraTypography>
                          <FloraTypography css={S.displayBlockCss} fontSize="bodyLargeStandard">
                            {formatDocumentNumber(member?.documentNumber, member?.documentType)}
                          </FloraTypography>
                        </Box>
                        <Box>
                          <FloraTypography fontSize="exceptionsAuxiliar">Saldo</FloraTypography>
                          <Flex align="baseline" color={isBlocked ? '$error-standard' : '$dark-light'} gapX="$1">
                            <FloraTypography css={S.displayBlockCss} fontSize="bodyLargeStandard">
                              {Number.parseInt(member?.total?.point || 0)}
                            </FloraTypography>
                            {!!isBlocked && (
                              <FloraTypography fontSize="exceptionsAuxiliar">(Bloqueado)</FloraTypography>
                            )}
                          </Flex>
                        </Box>
                      </Flex>
                    </Box>
                  </Box>
                </Flex>
              </Flex>
            </Flex>
          </FadeIn>
        </Box>
      )}
    </Box>
  )
}
export default HeaderDetails
